document.addEventListener("DOMContentLoaded", () => {

  const checkoutButton = document.querySelector('button[name="checkout"]');
  const cartForm = document.getElementById("CartDrawer-Form");

  const standard = document.getElementById("shipping-standard");
  const account = document.getElementById("shipping-account");

  const carrierSection = document.getElementById("carrier-section");
  const carrier = document.getElementById("carrier");

  const accountInput = document.getElementById("carrier-account");

  const ltlSection = document.getElementById("ltl-section");
  const ltlCarrier = document.getElementById("ltl-carrier");

  const instructions = document.querySelector(
    'textarea[name="attributes[shipping_instructions]"]'
  );

  const error = document.getElementById("account-error");

  const REGEX = {
    UPS: /^[A-Za-z0-9]{6}$/,
    FedEx: /^[0-9]{9}$/
  };

  checkoutButton.disabled = true;

  function clearCarrierFields() {

    const carrier = document.getElementById("carrier");
    const accountInput = document.getElementById("carrier-account");
    const ltlCarrier = document.getElementById("ltl-carrier");
    const ltlSection = document.getElementById("ltl-section");
    const error = document.getElementById("account-error");

    carrier.value = "";
    accountInput.value = "";
    ltlCarrier.value = "";
    ltlSection.style.display = "none";
    error.textContent = "";

}

  function validateCarrier() {

    const carrier = document.getElementById("carrier");
    const accountInput = document.getElementById("carrier-account");
    const ltlCarrier = document.getElementById("ltl-carrier");
    const error = document.getElementById("account-error");

    error.textContent = "";

    switch (carrier.value) {

      case "UPS":
        if (!REGEX.UPS.test(accountInput.value.trim())) {
          error.textContent =
            "UPS account must be 6 alphanumeric characters.";
          return false;
        }
        break;

      case "FedEx":
        if (!REGEX.FedEx.test(accountInput.value.trim())) {
          error.textContent =
            "FedEx account must be 9 digits.";
          return false;
        }
        break;

      case "DHL":
        if (accountInput.value.trim() === "") {
          error.textContent =
            "Account number is required.";
          return false;
        }
        break;

      case "LTL Freight":
        if (accountInput.value.trim() === "") {
          error.textContent =
            "Account number is required.";
          return false;
        }

        if (ltlCarrier.value.trim() === "") {
          error.textContent =
            "LTL Carrier Name is required.";
          return false;
        }
        break;

      default:
        error.textContent = "Please select a carrier.";
        return false;
    }

    return true;
  }

  function validateCheckout() {

    const checkoutButton = document.querySelector('button[name="checkout"]');

    if (!checkoutButton) return;

    const shippingMethod = document.querySelector(
      'input[name="attributes[shipping_method]"]:checked'
    );

    // No shipping method selected
    if (!shippingMethod) {
      checkoutButton.disabled = true;
      return;
    }

    // Standard Shipping
    if (shippingMethod.value === "Standard Shipping") {
      checkoutButton.disabled = false;
      return;
    }

    // Ship on My Account
    checkoutButton.disabled = !validateCarrier();
  }







  document.addEventListener("change", function (e) {

  const carrierSection = document.getElementById("carrier-section");
  const carrier = document.getElementById("carrier");
  const ltlSection = document.getElementById("ltl-section");
  const ltlCarrier = document.getElementById("ltl-carrier");

  if (!carrierSection || !carrier || !ltlSection || !ltlCarrier) return;

  if (e.target.id === "shipping-standard") {

    carrierSection.style.display = "none";

    carrier.value = "";
    document.getElementById("carrier-account").value = "";
    ltlCarrier.value = "";
    ltlSection.style.display = "none";

    validateCheckout();
  }

  if (e.target.id === "shipping-account") {

    carrierSection.style.display = "block";
    validateCheckout();
  }

  if (e.target.id === "carrier") {

    if (carrier.value === "LTL Freight") {
      ltlSection.style.display = "block";
    } else {
      ltlSection.style.display = "none";
      ltlCarrier.value = "";
    }

    validateCheckout();
  }

});


  document.addEventListener("input", function (e) {
  if (
    e.target.id === "carrier-account" ||
    e.target.id === "ltl-carrier"
  ) {
    validateCheckout();
  }

});



document.addEventListener("submit", async function (e) {

    if (e.target.id !== "CartDrawer-Form") return;

    const checkoutButton = document.querySelector('button[name="checkout"]');

    const instructions = document.querySelector(
        'textarea[name="attributes[shipping_instructions]"]'
    );

    validateCheckout();

    if (checkoutButton.disabled) {
        e.preventDefault();
        return;
    }

    e.preventDefault();

    const shippingMethod = document.querySelector(
        'input[name="attributes[shipping_method]"]:checked'
    );

    const attributes = {
        shipping_method: shippingMethod ? shippingMethod.value : "",
        carrier: "",
        carrier_account_number: "",
        ltl_carrier_name: "",
        shipping_instructions: instructions ? instructions.value.trim() : ""
    };

    if (
        shippingMethod &&
        shippingMethod.value === "Ship on My Account"
    ) {

        const carrier = document.getElementById("carrier");
        const accountInput = document.getElementById("carrier-account");
        const ltlCarrier = document.getElementById("ltl-carrier");

        attributes.carrier = carrier.value;
        attributes.carrier_account_number = accountInput.value.trim();

        attributes.ltl_carrier_name =
            carrier.value === "LTL Freight"
                ? ltlCarrier.value.trim()
                : "";
    }

    try {

        const response = await fetch("/cart/update.js", {

            method: "POST",

            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },

            body: JSON.stringify({
                attributes
            })

        });

        if (!response.ok) {
            throw new Error("Unable to update cart.");
        }

        await response.json();

        // Wait until Shopify finishes saving cart attributes
        await new Promise(resolve => setTimeout(resolve, 500));

        const cart = await fetch("/cart.js?t=" + Date.now(), {
            cache: "no-store"
        }).then(r => r.json());

        console.log("Cart Attributes", cart.attributes);

        if (
            shippingMethod &&
            shippingMethod.value === "Ship on My Account"
        ) {

            window.location.assign(
                "/discount/SHIPONACCOUNT?redirect=/checkout"
            );

        } else {

            window.location.assign("/checkout");

        }

    } catch (err) {

        console.error(err);
        alert("Unable to continue to checkout.");

    }

});


validateCheckout();


setInterval(() => {

  const btn = document.querySelector('button[name="checkout"]');
  if (!btn) return;

  // Call your existing validation
  validateCheckout();

}, 200);


console.log("SHIPPING RESTORE JS LOADED");

let savedShippingData = null;
let restoringShippingData = false;


// ==================================================
// 1. SAVE SHIPPING VALUES BEFORE QUANTITY CHANGE
// ==================================================

document.addEventListener("mousedown", function (e) {

  const btn = e.target.closest(".quantity__button");

  if (!btn) return;

  const shippingMethod = document.querySelector(
    'input[name="attributes[shipping_method]"]:checked'
  );

  const carrier = document.getElementById("carrier");
  const account = document.getElementById("carrier-account");
  const ltlCarrier = document.getElementById("ltl-carrier");

  savedShippingData = {

    shippingMethod: shippingMethod
      ? shippingMethod.value
      : "",

    carrier: carrier
      ? carrier.value
      : "",

    account: account
      ? account.value
      : "",

    ltlCarrier: ltlCarrier
      ? ltlCarrier.value
      : ""

  };

}, true);


// ==================================================
// 2. RESTORE SHIPPING VALUES
// ==================================================

function restoreShippingData() {

  if (!savedShippingData || restoringShippingData) {
    return;
  }

  restoringShippingData = true;

  const data = savedShippingData;


  // ----------------------------------------------
  // Shipping Method
  // ----------------------------------------------

  const shippingStandard =
    document.getElementById("shipping-standard");

  const shippingAccount =
    document.getElementById("shipping-account");


  if (
    data.shippingMethod === "Ship on My Account"
  ) {

    if (shippingAccount) {
      shippingAccount.checked = true;
    }

  } else if (
    data.shippingMethod === "Standard Shipping"
  ) {

    if (shippingStandard) {
      shippingStandard.checked = true;
    }

  }


  // ----------------------------------------------
  // Ship on My Account fields
  // ----------------------------------------------

  if (
    data.shippingMethod ===
    "Ship on My Account"
  ) {

    const carrier =
      document.getElementById("carrier");

    const account =
      document.getElementById("carrier-account");

    const ltlCarrier =
      document.getElementById("ltl-carrier");


    // Carrier
    if (carrier) {

      carrier.value =
        data.carrier;

    }


    // Account Number
    if (account) {

      account.value =
        data.account;

      account.dispatchEvent(
        new Event("input", {
          bubbles: true
        })
      );

    }


    // LTL Carrier
    if (
      data.carrier ===
      "LTL Freight" &&
      ltlCarrier
    ) {

      ltlCarrier.value =
        data.ltlCarrier;

    }


    // Make sure carrier section is visible
    const carrierSection =
      document.getElementById("carrier-section");

    if (carrierSection) {
      carrierSection.style.display = "block";
    }


    // LTL section
    const ltlSection =
      document.getElementById("ltl-section");

    if (ltlSection) {

      if (data.carrier === "LTL Freight") {
        ltlSection.style.display = "block";
      } else {
        ltlSection.style.display = "none";
      }

    }

  }


  // Clear saved data after ONE successful restore
  savedShippingData = null;

  restoringShippingData = false;

}


// ==================================================
// 3. OBSERVE WHOLE DOCUMENT
// ==================================================

const observer = new MutationObserver(function () {

  if (!savedShippingData) {
    return;
  }

  if (restoringShippingData) {
    return;
  }


  const shippingStandard =
    document.getElementById("shipping-standard");

  const shippingAccount =
    document.getElementById("shipping-account");


  // Shipping section has been recreated
  if (
    shippingStandard ||
    shippingAccount
  ) {

    restoreShippingData();

  }

});


observer.observe(document.body, {
  childList: true,
  subtree: true
});


});


